import CheckboxSelectAll from 'stimulus-checkbox-select-all';
export default CheckboxSelectAll;
